<template>
    <div>
        <Navbar />
        <PageTitle />
        <SignUp />
        <FooterTop />
        <FooterBottom />
    </div>
</template>

<script>
import Navbar from '../Layout/Navbar'
import PageTitle from '../SignIn/PageTitle'
import SignUp from '../SignIn/SignUp'
import FooterTop from '../Layout/FooterTop'
import FooterBottom from '../Layout/FooterBottom'

export default {
    name: 'SignInPage',
    components: {
        Navbar,
        PageTitle,
        SignUp,
        FooterTop,
        FooterBottom,
    }
}
</script>
